import React from "react";

/**
 * Highlights parts of the text that match the search input.
 *
 * @param text - The original text to display
 * @param searchInput - The text to highlight
 */
export function highlightText(text: string, searchInput: string): React.ReactNode {
    const escapedInput = searchInput.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escapedInput.split(" ").filter(Boolean).join("|")})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, i) =>
        regex.test(part) ? <strong key={i}>{part}</strong> : <span key={i}>{part}</span>
    );
}
